
















































import { Vue, Component, Prop } from "vue-property-decorator";

@Component({})
export default class ListableItemWrapper extends Vue {
  @Prop({ default: "+ New Item" }) private newItemText!: string;
  @Prop({ default: () => () => ({}) }) private templateItem!: () => unknown;
  @Prop({ default: () => [] }) private items!: unknown[];

  private openPanels: number[] = [];
  private deleteIndex: number = -1;
  private timeout: number | undefined = undefined;

  private newItem() {
    const item = Object.assign({}, this.templateItem());

    this.$emit("newItem", item);

    this.openPanels = [];
    this.openPanels.push(this.items.length - 1);
  }

  private removeItem(itemIndex: number) {
    this.$emit("removeItem", itemIndex);
  }

  private confirmDeleting(index: number) {
    clearTimeout(this.timeout);

    if (index === this.deleteIndex) {
      this.removeItem(index);
      this.deleteIndex = -1;
    } else if (index !== this.deleteIndex) {
      this.deleteIndex = index;
      this.timeout = setTimeout(() => {
        this.deleteIndex = -1;
      }, 5000);
    }
  }
}
